import { render, staticRenderFns } from "./EmptyTableCard.vue?vue&type=template&id=2528bea6&"
import script from "./EmptyTableCard.vue?vue&type=script&lang=js&"
export * from "./EmptyTableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports